import $ from 'cash-dom';
import DeviceSizes from './DeviceSizes';

const ShowQrCode = {
	_showQr: null,

	init() {
		this._elementsReinit();

		if (window.innerWidth > DeviceSizes.MD) {
			const linksWithQrCode = $('.ppc-single-vendor.has-qr a:not(.read-review-link), .ppc-single-vendor.has-qr[data-href], .ppc-single-vendor.has-qr [data-href]'
				+ ', .top-vendor.has-qr a:not(.read-review-link), .top-vendor.has-qr[data-href], .top-vendor.has-qr [data-href]'
				+ ', .top-product.has-qr a:not(.read-review-link), .top-product.has-qr[data-href], .top-product.has-qr [data-href]');

			linksWithQrCode.each((i, el) => {
				$(el).addClass('unbind-alooma-clickout');
			});

			linksWithQrCode.on('click', function (e) {
				e.preventDefault();
				e.stopPropagation();
			});
		}

		this._setQrCodeImages();

		$(document).on('alooma-click-index-done', () => {
			this._setQrCodeImages();
		});
	},

	_setQrCodeImages() {
		this._showQr.each((i, showQrLinkEl) => {
			const showQrLink = $(showQrLinkEl);
			const $nextImage = showQrLink.next('img.qr-code');

			const url = encodeURIComponent(showQrLink.attr('href'));
			const $img = $('<img class="qr-code" src="/qr_generator.png?url=' + url
				+ '" data-url="' + url + '">');

			$nextImage.remove();
			showQrLink.after($img);
		});
	},

	_elementsReinit() {
		this._showQr = $('.show-qr');
	},
};

$(function () {
	ShowQrCode.init();
});

export default ShowQrCode;